import { AccountCode } from '../interfaces/AccountCodeInterface';
import client from './client';

/**
 * Fetches all account codes from the API.
 */
export const getAllAccountCodes = async (): Promise<AccountCode[]> => {
    try {
        const response = await client.get("/admin//accountCode");
        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching account codes:", error);
        throw new Error("Failed to fetch account codes");
    }
};
